import { useAuthStore } from './authStore';

/**
 * Derived hook that checks if the current user has an active premium subscription.
 * Replaces the previous localStorage-based zustand store.
 */
export function useIsPremium(): boolean {
  const plan = useAuthStore((s) => s.user?.plan);
  return !!plan && plan !== 'free';
}

/**
 * @deprecated Use `useIsPremium()` hook instead.
 * Kept for backward compatibility — returns an object with `isPremium` boolean.
 */
export const usePremiumStore = (selector: (s: { isPremium: boolean }) => unknown) => {
  const isPremium = useIsPremium();
  return selector({ isPremium });
};
